import React from "react";

const MinedTime = () => {
  return (
    <div className="text-center p-5 text-blue-800 bg-white drop-shadow-lg rounded">
      <div>
        <h3>Mined Time</h3>
      </div>
      <div>
        <h2 className="text-2xl py-2 mb-3 text-orange-500">0.00000099</h2>
      </div>
    </div>
  );
};

export default MinedTime;
